import React from "react"

const toneMap = {
  danger: {
    background: "#fef2f2",
    border: "#fecaca",
    color: "#991b1b",
    icon: "🔒"
  },
  warning: {
    background: "#fff7ed",
    border: "#fed7aa",
    color: "#c2410c",
    icon: "⚠️"
  },
  info: {
    background: "#eff6ff",
    border: "#bfdbfe",
    color: "#1d4ed8",
    icon: "ℹ️"
  },
  success: {
    background: "#f0fdf4",
    border: "#bbf7d0",
    color: "#166534",
    icon: "✅"
  }
}

export default function StatusBanner({
  tone = "info",
  title,
  text,
  icon,
  style = {}
}) {
  const visual = toneMap[tone] || toneMap.info

  return (
    <div
      style={{
        border: `1px solid ${visual.border}`,
        background: visual.background,
        color: visual.color,
        borderRadius: 14,
        padding: 12,
        display: "flex",
        gap: 10,
        alignItems: "flex-start",
        ...style
      }}
    >
      <div style={{ fontSize: 16, lineHeight: 1 }}>
        {icon || visual.icon}
      </div>

      <div style={{ minWidth: 0 }}>
        {title ? (
          <div
            style={{
              fontWeight: 900,
              marginBottom: text ? 4 : 0
            }}
          >
            {title}
          </div>
        ) : null}

        {text ? (
          <div
            style={{
              fontSize: 13,
              lineHeight: 1.45
            }}
          >
            {text}
          </div>
        ) : null}
      </div>
    </div>
  )
}